import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AvatarModule } from 'primeng/avatar';
import { MenubarModule } from 'primeng/menubar';
import { BreadcrumbsMenuComponent } from '../breadcrumbs-menu';
import { SettingsMenuComponentModule } from '../settings-menu';
import { HeaderLogoComponent } from './header-logo';
import { HeaderComponent } from './header.component';
import { ChatComponent } from '../chat';

@NgModule({
  declarations: [HeaderComponent, HeaderLogoComponent],
  exports: [HeaderComponent, ChatComponent],
  imports: [
    CommonModule,
    MenubarModule,
    AvatarModule,
    SettingsMenuComponentModule,
    TranslateModule,
    BreadcrumbsMenuComponent,
    ChatComponent,
  ],
})
export class HeaderComponentModule {}
